import { render, staticRenderFns } from "./Form3.vue?vue&type=template&id=47ea5ffc&scoped=true"
import script from "./Form3.vue?vue&type=script&lang=js"
export * from "./Form3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea5ffc",
  null
  
)

export default component.exports